export const DEFAULT_REPORT_SECTIONS = [
    { key: "summary", enabled: true, title: "Week at a glance", order: 10 },
    { key: "leaderboard", enabled: true, title: "Leaderboard", order: 20 },
    { key: "categoryBreakdown", enabled: true, title: "Where the points came from", order: 30 },
    { key: "dailyProgress", enabled: true, title: "Daily progress", order: 40 },
    { key: "eventWins", enabled: true, title: "Wins and highlights", order: 50 },
    { key: "onTime", enabled: true, title: "On-time record", order: 60 },
    { key: "achievements", enabled: true, title: "Achievements", order: 70 },
    { key: "topMoments", enabled: true, title: "Top moments", order: 80 },
    { key: "comment", enabled: true, title: "Staff note", order: 90 },
    { key: "detailedEntries", enabled: false, title: "Detailed entries", order: 100 }
];
export const DEFAULT_REPORT_TEMPLATES = [
    {
        id: "weekly-report",
        name: "Weekly Cabin Report",
        description: "Balanced one-page report with totals, progress, wins, and achievements.",
        enabled: true,
        isDefault: true,
        layout: "standard",
        sections: DEFAULT_REPORT_SECTIONS.map((section) => ({ ...section })),
        style: {
            logoTreatment: "blend",
            headerStyle: "brandBand",
            density: "comfortable",
            showCabinColorBand: true
        }
    },
    {
        id: "simple-summary",
        name: "Simple Summary",
        description: "A clean short report for fast printing.",
        enabled: true,
        isDefault: false,
        layout: "standard",
        sections: DEFAULT_REPORT_SECTIONS.map((section) => ({
            ...section,
            enabled: ["summary", "categoryBreakdown", "achievements", "comment"].includes(section.key)
        })),
        style: {
            logoTreatment: "blend",
            headerStyle: "minimal",
            density: "compact",
            showCabinColorBand: true
        }
    },
    {
        id: "folded-booklet",
        name: "Folded Booklet",
        description: "Eight mini-pages imposed for two landscape A4 sheets, double-sided short-edge.",
        enabled: true,
        isDefault: false,
        layout: "booklet",
        sections: DEFAULT_REPORT_SECTIONS.map((section) => ({ ...section, enabled: true })),
        style: {
            logoTreatment: "blend",
            headerStyle: "brandBand",
            density: "comfortable",
            showCabinColorBand: true
        }
    }
];
export const DEFAULT_ACHIEVEMENT_RULES = [
    {
        id: "always-ready",
        name: "Always Ready",
        icon: "⏰",
        descriptionTemplate: "On time {value} times this week.",
        enabled: true,
        metric: "categoryOccurrences",
        categoryId: "on-time",
        comparator: "gte",
        threshold: 10,
        showOnReport: true,
        sortOrder: 10
    },
    {
        id: "perfect-timing",
        name: "Perfect Timing",
        icon: "✓",
        descriptionTemplate: "A perfect {value}% on-time record.",
        enabled: true,
        metric: "onTimeRate",
        categoryId: "on-time",
        comparator: "gte",
        threshold: 100,
        showOnReport: true,
        sortOrder: 20
    },
    {
        id: "wide-game-winner",
        name: "Wide Game Winner",
        icon: "🏆",
        descriptionTemplate: "Won {value} Wide Game event(s).",
        enabled: true,
        metric: "categoryWins",
        categoryId: "wide-game",
        comparator: "gte",
        threshold: 1,
        showOnReport: true,
        sortOrder: 30
    },
    {
        id: "points-leader",
        name: "Camp Points Leader",
        icon: "★",
        descriptionTemplate: "Finished the week in first place with {value} points.",
        enabled: true,
        metric: "overallRank",
        categoryId: null,
        comparator: "rankAtMost",
        threshold: 1,
        showOnReport: true,
        sortOrder: 40
    }
];
